import { GamesCountLabel } from './components/GamesCountLabel/GamesCountLabel';
import { TagsContainer } from './components/TagsContainer/TagsContainer';
import { ViewControls } from './components/ViewControls/ViewControls';

function CasinoCategoryPageControls() {
  return (
    <>
      <div className="flex items-center justify-between ll-container-inner pl-10">
        <div className="paragraph-s-strong text-foreground-subtle min-h-5 flex items-center" data-track-name="Results" data-testid="games-counter">
          <GamesCountLabel />
        </div>
        <ViewControls />
      </div>
      <TagsContainer className="ll-container-inner-full px-[var(--ll-container-padding)] md:px-0 md:ll-container-inner" />
    </>
  );
}

export { CasinoCategoryPageControls };
